import React, { useContext, useEffect, useState } from 'react';
import { formatterPhone as utilsFormatterPhone } from '../../../../utils/formatters/formatter';
import { TaskContext } from '../Payoff';
import { Form } from 'antd';
import { useGetTaskResponsesByTask } from '../../../../services/task/querys';
import { useCreateResponseTask } from '../../../../services/task/mutations';
import { Task, TaskResponse, TaskState } from '../../../../gql/graphql';
import InputBorderNone from '../../components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import ButtonSubmit from '../../components/Atoms/Buttons/ButtonSubmit/ButtonSubmit';
import StateTag from '../../components/Atoms/Tags/StateTag/StateTag';
import ActionAcceptAndReject from '../../../ActionAcceptAndReject/ActionAcceptAndReject';

interface IForm {
	titleCompany: string;
	name: string;
	phone: string;
	email: string;
}

interface Props {
	setModalFinishTask: any;
}

const CardLender = ({ setModalFinishTask }: Props) => {
	const [form] = Form.useForm();
	const task: Task | any = useContext(TaskContext);

	const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
		variables: { findResponsesByTask: { taskId: task._id } }
	});
	const { fetching, execute: createResponseTask } = useCreateResponseTask();

	const [responseLender, setResponseLender] = useState<TaskResponse | any>();

	useEffect(() => {
		const _response = taskResponses?.find((item) => item.step === 2 && item.key === 'payoff-lender');
		setResponseLender(_response);
	}, [taskResponses]);

	useEffect(() => {
		if (responseLender)
			form.setFieldsValue(responseLender.metadata);
	}, [responseLender])

	const formatterPhone = (e: any) => {
		form.setFieldValue('phone', utilsFormatterPhone(e.target.value));
	};

	const onFinish = async (values: IForm) => {
		await createResponseTask({
			task: task._id,
			key: `payoff-lender`,
			label: `Current Lender`,
			step: 2,
			metadata: values,
			state: TaskState.Review
		});

		getTaskResponses({ requestPolicy: 'network-only' });
		setModalFinishTask(true);
	}

	return (
		<div style={{ position: 'relative' }} className={`title-company-step-1 title-company-step-1-${responseLender?.state}`}>
			{responseLender?.state && responseLender?.state !== TaskState.Review && <StateTag state={responseLender?.state} />}
			{responseLender?.state && responseLender?.state === TaskState.Review && <StateTag state={responseLender?.state} isLabelLocked />}
      <ActionAcceptAndReject
        taskResponseId={responseLender?._id}
        task={{ id: task._id, key: task.key, name: task.name }}
        files={responseLender?.files}
        currentState={responseLender?.state}
      />
			<Form
				name="edit"
				autoComplete="off"
				requiredMark="optional"
				colon={false}
				form={form}
				onFinish={onFinish}
			>
				<Form.Item
					label=""
					name="lenderName"
					className="titleCompany"
					rules={[{ required: true, message: '' }]}
				>
					<InputBorderNone
						placeholder="Lender name"
						className="bold"
					/>
				</Form.Item>
				<Form.Item
					label="Contact name (if different from lender)"
					name="name"
					className="name"
					rules={[{ required: true, message: '' }]}
				>
					<InputBorderNone
						placeholder="Edgar"
						height={20}
						className="bold-lith"
					/>
				</Form.Item>

				<Form.Item
					label="Phone number"
					name="phone"
					className="phone"
					rules={[
						{ required: true, message: '' },
						{ min: 12, message: '' }
					]}
				>
					<InputBorderNone
						placeholder="329-230-2390"
						height={20}
						className="bold-lith"
						onChange={formatterPhone}
					/>
				</Form.Item>

				<Form.Item
					label="Email address"
					name="email"
					className="email"
					rules={[{ required: true, type: 'email', message: '' }]}
				>
					<InputBorderNone
						type="email"
						placeholder="ricardo@mervetscoolbiz.com"
						height={20}
						className="bold-lith"
					/>
				</Form.Item>

				<Form.Item className="submit" shouldUpdate>
					{() => (
						<ButtonSubmit
							disabled={
								!!responseLender ||
								!form.getFieldsError().every((fieldErr) => fieldErr.errors.length === 0) ||
								!form.isFieldsTouched() ||
								!Object.values(form.getFieldsValue()).every(value => value)
							}
							loading={fetching}
							modalConfirm={{ show: true }}
							onClick={form.submit}
						>
							Submit for review
						</ButtonSubmit>
					)}
				</Form.Item>
			</Form>
		</div>
	);
};

export default CardLender;